export function getBreaks(values: number[], divisions: number) {

    var count = values.length;

    if (count <= divisions) {
        return values;
    }

    var step = count / divisions;
    var p = 0;
    var ip = 0;
    var last = count - 1;

    var results: number[] = [];
    results.push(values[0]);

    do {
        p += step;
        ip = Math.min(last, Math.round(p));
        results.push(values[ip]);
    } while (ip < last);

    return results;

}

